<div class="list-builder-panel">
  <div class="list-header">
    <div class="header-top">
      <div class="list-selector">
        <select (change)="selectList($event.target.value)">
          <option value="">Select a list...</option>
          <option *ngFor="let list of lists" [value]="list.key" [selected]="activeList?.key === list.key">
            {{list.name}} ({{list.memberCount}})
          </option>
        </select>
      </div>
      <div class="btn-new" (click)="createNewList()" title="New List">+</div>
      <div class="btn-close" (click)="close()" title="Close">&times;</div>
    </div>
    <div *ngIf="activeList" class="header-name">
      <ng-container *ngIf="!editingName">
        <span class="list-name" (dblclick)="startEditName()">{{activeList.name}}</span>
        <span class="member-count">({{members?.length || 0}} items)</span>
        <div class="btn-delete" (click)="deleteList()" title="Delete List"></div>
      </ng-container>
      <ng-container *ngIf="editingName">
        <input class="name-input" [(ngModel)]="editName"
          (keydown.enter)="saveName()" (keydown.escape)="cancelEditName()" (blur)="saveName()"
          autofocus />
      </ng-container>
    </div>
  </div>

  <ng-container *ngIf="activeList">
    <div class="list-table">
      <div class="header-row-wrapper">
        <div class="list-table-header" [style.margin-left.px]="tsl*-1">
          <div *ngFor="let field of activeFields" class="field" [style.flex-basis.px]="field.width">
            {{field.name}}
          </div>
        </div>
      </div>

      <div class="list-items" #listItemsEl (scroll)="onListScroll($event)">
        <div *ngFor="let item of members"
             class="list-row"
             [class.loading]="item._loading"
             [class.active]="item._id === activeDocumentId"
             (click)="openDetail(item)">
          <div class="remove-arrow" (click)="onRemoveClick($event, item._id)">&#x2039;</div>
          <div *ngFor="let field of activeFields" class="field" [style.flex-basis.px]="field.width">
            {{getValueByPath(item, field.path) | rf:field.type}}
          </div>
        </div>
        <div *ngIf="members?.length === 0" class="empty-state">
          No items in this list yet.
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!activeList">
    <div class="empty-state center">
      Select an existing list or create a new one.
    </div>
  </ng-container>

  <div *ngIf="activeList" class="list-footer">
    <div *ngFor="let action of visibleListActions()" class="footer-btn"
         [ngClass]="action.class" (click)="runListAction(action)"
         [title]="action.title || action.name">
      {{ action.name }}
    </div>
  </div>
</div>
